import { render, staticRenderFns } from "./cadastroCredenciados.vue?vue&type=template&id=c1b0e08c&lang=pug&"
import script from "./cadastroCredenciados.vue?vue&type=script&lang=js&"
export * from "./cadastroCredenciados.vue?vue&type=script&lang=js&"
import style0 from "./cadastroCredenciados.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports